<template>
  <div class="select-user">
    <div class="user-selection-actions">
      <button class="btn btn-tertiary search-button" @click="searchForLearnerSupport">
        <i class="fas fa-search" aria-hidden="true"></i> {{ searchText }}
      </button>
      <button v-if="showClearButton" class="btn btn-primary clear-selection" @click="revertToDefaultMeetingOwner">
        <i class="fas fa-times" aria-hidden="true"></i> Clear Selection
      </button>
    </div>
    <k-user-search
        @close="showUserSearch = false"
        @select="handleUserSelection"
        :allowSelect="true"
        :displayUserLinks="false"
        :show="showUserSearch">
    </k-user-search>
    <div
      class="profile-cards-container"
      :class="{ 'profile-cards-container--split': hasAdjacentProfile }"
    >
      <user-profile-card class="flexible-panel"
                         :name="currentMeetingOwnerData.full_name"
                         :email="currentMeetingOwnerData.email"
                         :avatarUrl="currentMeetingOwnerData.avatar_url"
                         :role="currentMeetingOwnerData.learner_support_type"
                         :userId="currentMeetingOwnerData.id"
      ></user-profile-card>
      <slot name="adjacent-profile"></slot>
    </div>
  </div>
</template>

<style scoped>
.profile-cards-container--split {
  display: flex;
  gap: 15px;
}

.profile-cards-container--split .user-profile-card,
.profile-cards-container--split :slotted(*) {
  flex: 1;
  min-width: 0;
}
</style>

<script>
import useGlobalStore from '@stores/global';
import KUserSearch from '../../../components/user-search.vue';
import UserProfileCard from '../../../../components/user-profile-card.vue';

export default {

  components: {
    UserProfileCard,
    KUserSearch,
  },

  props: {
    // This ideally needs to be a v-model
    modelValue: {
      type: Object,
    },
    defaultMeetingOwner: {
      type: Object,
      default: null,
    },
    showClearButton: {
      type: Boolean,
      default: true,
    },
    splitProfileCards: {
      type: Boolean,
      default: false,
    },
    searchText: {
      type: String,
      default: 'Search for User',
    },
  },

  data() {
    return {
      store: useGlobalStore(),
      showUserSearch: false,
      meetingOwner: {},
    };
  },

  mounted() {
    this.$emit('update:modelValue', this.currentMeetingOwnerData);
  },

  computed: {
    currentMeetingOwnerData() {
      if (this.modelValue.id) {
        return this.modelValue;
      }
      if (this.defaultMeetingOwner) {
        return this.defaultMeetingOwner;
      }
      return {};
    },
    hasAdjacentProfile() {
      return this.splitProfileCards;
    },
  },

  methods: {
    searchForLearnerSupport() {
      this.showUserSearch = true;
    },

    handleUserSelection(userId) {
      this.$logger.info(`Getting user ${userId} for meeting owner`);
      this.$http.get(`/api/profile/users/${userId}`)
        .then(result => {
          this.meetingOwner = result.data;
          this.$emit('update:modelValue', result.data);
        }).catch(err => {
          this.$logger.error('Error getting user', undefined, err);
          this.$ktoast.showError(err);
        }).then(() => {
          this.showUserSearch = false;
        });
    },

    revertToDefaultMeetingOwner() {
      this.meetingOwner = {};
      this.$emit('reset-meeting-owner', this.defaultMeetingOwner || {});
    },
  },
};
</script>
